import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { MapIcon, SearchIcon, MessageSquareIcon, MousePointerClickIcon, BookOpenIcon, CalendarIcon } from 'lucide-react';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
      delayChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: [0.25, 0.46, 0.45, 0.94]
    }
  }
};
export function IncludesSection() {
  return <section className="bg-[#111111] px-5 py-16 md:py-24" data-id="element-105">
      <motion.div className="max-w-3xl mx-auto" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
      once: true,
      margin: '-100px'
    }} data-id="element-106">
        <motion.h2 variants={itemVariants} className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4" data-id="element-107">
          Qué incluye
        </motion.h2>
        <motion.p variants={itemVariants} className="text-[#A0A0A0] text-lg md:text-xl mb-10" data-id="element-108">
          Contenido + herramientas
        </motion.p>

        <div className="space-y-4" data-id="element-109">
          <motion.div variants={itemVariants} className="bg-[#0A0A0A] p-5 rounded-lg border border-[#2A2A2A] flex items-start gap-4" data-id="element-110">
            <div className="flex-shrink-0 w-10 h-10 bg-[#E8732A]/10 rounded-lg flex items-center justify-center" data-id="element-111">
              <MapIcon className="w-5 h-5 text-[#E8732A]" data-id="element-112" />
            </div>
            <div data-id="element-113">
              <p className="text-white font-semibold mb-1" data-id="element-114">
                El mapa completo de las 3-Puertas de Conversión
              </p>
              <p className="text-[#A0A0A0] text-sm" data-id="element-115">
                Entiende exactamente dónde se rompe tu embudo
              </p>
            </div>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-[#0A0A0A] p-5 rounded-lg border border-[#2A2A2A] flex items-start gap-4" data-id="element-116">
            <div className="flex-shrink-0 w-10 h-10 bg-[#E8732A]/10 rounded-lg flex items-center justify-center" data-id="element-117">
              <SearchIcon className="w-5 h-5 text-[#E8732A]" data-id="element-118" />
            </div>
            <div data-id="element-119">
              <p className="text-white font-semibold mb-1" data-id="element-120">
                Auditoría de 10 minutos
              </p>
              <p className="text-[#A0A0A0] text-sm" data-id="element-121">
                Detecta dónde se muere tu venta
              </p>
            </div>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-[#0A0A0A] p-5 rounded-lg border border-[#2A2A2A] flex items-start gap-4" data-id="element-122">
            <div className="flex-shrink-0 w-10 h-10 bg-[#E8732A]/10 rounded-lg flex items-center justify-center" data-id="element-123">
              <MessageSquareIcon className="w-5 h-5 text-[#E8732A]" data-id="element-124" />
            </div>
            <div data-id="element-125">
              <p className="text-white font-semibold mb-1" data-id="element-126">
                Mapa de DM en 4 mensajes
              </p>
              <p className="text-[#A0A0A0] text-sm" data-id="element-127">
                Enganche → filtro → recomendación → cierre suave
              </p>
            </div>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-[#0A0A0A] p-5 rounded-lg border border-[#2A2A2A] flex items-start gap-4" data-id="element-128">
            <div className="flex-shrink-0 w-10 h-10 bg-[#E8732A]/10 rounded-lg flex items-center justify-center" data-id="element-129">
              <MousePointerClickIcon className="w-5 h-5 text-[#E8732A]" data-id="element-130" />
            </div>
            <div data-id="element-131">
              <p className="text-white font-semibold mb-1" data-id="element-132">
                Plantillas de CTA con palabra clave
              </p>
              <p className="text-[#A0A0A0] text-sm" data-id="element-133">Para TikTok e Instagram</p>
            </div>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-[#0A0A0A] p-5 rounded-lg border border-[#2A2A2A] flex items-start gap-4" data-id="element-134">
            <div className="flex-shrink-0 w-10 h-10 bg-[#E8732A]/10 rounded-lg flex items-center justify-center" data-id="element-135">
              <BookOpenIcon className="w-5 h-5 text-[#E8732A]" data-id="element-136" />
            </div>
            <div data-id="element-137">
              <p className="text-white font-semibold mb-1" data-id="element-138">
                Biblioteca de pruebas seguras para cursos
              </p>
              <p className="text-[#A0A0A0] text-sm" data-id="element-139">
                Demo, proceso, micro-resultado
              </p>
            </div>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-[#0A0A0A] p-5 rounded-lg border border-[#2A2A2A] flex items-start gap-4" data-id="element-140">
            <div className="flex-shrink-0 w-10 h-10 bg-[#E8732A]/10 rounded-lg flex items-center justify-center" data-id="element-141">
              <CalendarIcon className="w-5 h-5 text-[#E8732A]" data-id="element-142" />
            </div>
            <div data-id="element-143">
              <p className="text-white font-semibold mb-1" data-id="element-144">Sprint de 7 días</p>
              <p className="text-[#A0A0A0] text-sm" data-id="element-145">
                Qué ajustar cada día y qué medir
              </p>
            </div>
          </motion.div>
        </div>
      </motion.div>
    </section>;
}